/** v1.4.1 素材清單（manifest.json）：獨立一個小檔，main.ts 一開機就能抓，不用等 3D 引擎下載完 */
const BASE = `${import.meta.env.BASE_URL}assets/`;
/** v1.4.1 越早開始抓越好：main.ts 一開機就呼叫（和下載遊戲本體同時進行） */
let pending: Promise<Set<string>> | null = null;
export function prefetchManifest(): Promise<Set<string>> {
  if (pending) return pending;
  // 單檔離線版（file:// 或嵌入預覽）沒有素材資料夾：全部使用程式生成的替代品
  if (import.meta.env.MODE === 'offline' || location.protocol === 'file:') return (pending = Promise.resolve(new Set<string>()));
  pending = fetch(`${BASE}manifest.json`, { cache: 'no-cache' })
    .then(res => (res.ok ? res.json() : { files: [] }))
    .then((j: { files?: string[] }) => new Set<string>(j.files ?? []))
    .catch(() => new Set<string>());
  return pending;
}
